import NextHead from "next/head";

const Head = () => {
  return (
    <NextHead>
      <title>Bio e-learning - Géneration devis</title>
      <meta name="description" content="Bio e-learning - Géneration devis" />
      <link
        rel="icon"
        href="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>🧬</text></svg>"
      />
    </NextHead>
  );
};

export default Head;
